import useCallApi from '../../utilities/axios'

export type SubmittedAdditionalRequest = {
    submittedAdditionalTab: SubmittedAdditionalTab
    items: SubmittedAdditionalItem[]
}

export type SubmittedAdditionalDetail = SubmittedAdditionalRequest

export type SubmittedAdditionalItem = {
    considerTypeID: number
    value: number
}

export enum SubmittedAdditionalTab {
    isRequestCopy = 'IS_REQUEST_COPY',
    copies = 'COPIES',
    extensionDays = 'EXTENSION_DAYS',
}

export const useSettingSystem = () => {
    const callApi = useCallApi()

    const getSubmittedAdditionalSetting = async () => {
        const { data } = await callApi.axiosGet<any>({
            url: `${process.env.REACT_APP_CU_IRB_API_URL}/setting/submitted-additional`,
        })

        return data
    }

    const updateSubmittedAdditionalSetting = async (values: SubmittedAdditionalRequest) => {
        const { data } = await callApi.axiosPost<any>({
            url: `${process.env.REACT_APP_CU_IRB_API_URL}/setting/submitted-additional`,
            params: values,
        })

        return data
    }

    return {
        getSubmittedAdditionalSetting,
        updateSubmittedAdditionalSetting,
    }
}
